import { FunctionComponent } from "react"
import { useNavigate } from "react-router-dom"

const RecruiterWelcomePage: FunctionComponent = () => {
  const navigate = useNavigate()

  const options = [
    {
      label: "Send Simulations",
      description: "Invite candidates to complete a 30-minute simulation. You'll see cognitive insights that interviews can't reveal.",
      destination: "/dashboard/recruiter-admin/users/all",
    },
    {
      label: "View Results",
      description: "Explore candidate cognitive blueprints. See who thinks in ways that match what the role demands.",
      destination: "/dashboard/recruiter-admin/scores",
    },
    {
      label: "Compare Candidates",
      description: "Stack candidates against each other and against high-performer baselines in your industry.",
      destination: "/dashboard/recruiter-admin/benchmarks",
    },
  ]

  return (
    <div className="min-h-full bg-gray-50 flex flex-col items-center justify-center py-16 px-8">
      <div className="w-full max-w-4xl">
        {/* Centered Header */}
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Welcome to Meseekna
          </h1>
          <p className="text-xl text-gray-500">
            Predict candidate performance before day one—not after it&apos;s too late.
          </p>
        </div>

        {/* Value Proposition Banner */}
        <div className="bg-[#4d86ff] rounded-xl p-6 mb-10 text-white text-center">
          <h2 className="text-xl font-bold mb-2">
            Hiring That&apos;s 7X More Predictive
          </h2>
          <p className="text-white/90 leading-relaxed max-w-2xl mx-auto">
            Traditional interviews miss 86% of what predicts success. Our simulations capture how candidates actually think and make decisions—the cognitive patterns that determine real-world performance.
          </p>
        </div>

        {/* Section Header */}
        <h3 className="text-lg font-semibold text-gray-700 mb-6 text-center">
          Where would you like to start?
        </h3>

        {/* Quick Start Cards - matching Admin style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          {options.map((option) => (
            <button
              key={option.label}
              onClick={() => navigate(option.destination)}
              className="bg-white rounded-xl border-2 border-gray-200 p-6 text-center hover:border-[#4d86ff] hover:shadow-lg transition-all group"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-1 group-hover:text-[#4d86ff] transition-colors">
                {option.label}
              </h3>
              <p className="text-sm text-gray-500">{option.description}</p>
            </button>
          ))}
        </div>

        {/* Social Proof Quote */}
        <div className="text-center text-gray-500 italic max-w-2xl mx-auto">
          <p className="mb-2">
            &ldquo;[Meseekna] is the first and only instrument that has allowed me to gain insight into the managers who work for me.&rdquo;
          </p>
          <p className="text-sm not-italic text-gray-400">
            — Executive, Global Financial Services
          </p>
        </div>
      </div>
    </div>
  )
}

export default RecruiterWelcomePage
